// local
import * as Assets from "./assets";
import { AssetType } from "./AssetType";

export const getAssetTypes = ():AssetType[] => {
	const assets = Object.keys(Assets).map(k => (Assets as any)[k]) as AssetType[];
	return assets.filter(a => !a.disabled);
	// return assets;
};
